import React from 'react';
import {IonIcon, useIonAlert} from '@ionic/react';
import {
    bookmark, bookmarkOutline,
    chevronBackOutline,
    downloadOutline,
    shareSocialOutline
} from "ionicons/icons";
import {FacebookLoader} from "./Loader/FacebookLoader";
import moment from "moment-timezone";
import { Share } from '@capacitor/share';
import {Capacitor} from '@capacitor/core';
import {actionToMarkUnmarkBookmarkNewsData} from "../apiHelpers/CommonAction";

export default function NewsDetailCard({newsDetailsData,onDidDismiss}) {
    const [presentAlert] = useIonAlert();
    const isDesktop = window.innerWidth >= 1000;

    const callFunctionToDownloadPdf = (urlPath) => {
        if(!urlPath){
            presentAlert({
                header: 'Error Downloading!',
                message: 'No downloadable content found.',
                buttons: [{
                    text: 'Ok',
                }],
            });
            return;
        }
        const link = document.createElement('a');
        link.href = urlPath;

        // Extract file name from URL or set a default
        const fileName = urlPath.split('/').pop() || 'downloaded-file.pdf';
        link.download = fileName;

        // Trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
    };

    const callFunctionToBookmarkNews = async (news_id,is_bookmarked)=>{
        await actionToMarkUnmarkBookmarkNewsData({news_id},is_bookmarked)
    }

    const handleShareUrl = async (news) => {
        try {
            const url = `https://caworld.org/api-ca-world/common/shareAppContentData/news/${news?.id}`;
            const title = 'CA World News';
            const text = 'Check out this news!';


            // Prefer native Share plugin when running in a Capacitor app.
            // Don't gate on canShare() for text/URL — it's mainly helpful for FILE sharing.
            const isNative = Capacitor.getPlatform() !== 'web';
            const hasPlugin = Capacitor.isPluginAvailable?.('Share');

            if (isNative && hasPlugin) {
                await Share.share({
                    title,
                    text,
                    url,                  // supports http/https and file://
                    dialogTitle: 'Share this news', // Android only
                });
                return;
            }

            // Web Share API (must be triggered from a direct user gesture)
            if (navigator?.share) {
                await navigator.share({ title, text, url });
                return;
            }

            // Fallbacks
            try {
                await navigator?.clipboard?.writeText?.(url);
                presentAlert({
                    header: 'Error Sharing!',
                    message: 'Link copied to clipboard!',
                    buttons: [{
                        text: 'Ok',
                    }],
                });
            } catch {
                window.prompt('Sharing is not supported. Copy this link:', url);
            }
        } catch (err) {
            console.error('Sharing failed:', err);
            presentAlert({
                header: 'Error Sharing!',
                message: 'Failed to share!',
                buttons: [{
                    text: 'Ok',
                }],
            });
        }
    };

    return (
        <React.Fragment>
            {(newsDetailsData?.id) ?
                <>
                    <div className="news-detail-image-wrapper" data-publisher-content="true">
                        <img src={newsDetailsData.image_url} alt="News"/>
                        <div className="news-detail-top-buttons">
                            {(onDidDismiss) ?
                                <button onClick={onDidDismiss} className="circle-btn">
                                    <IonIcon icon={chevronBackOutline}/>
                                </button>:''
                            }
                            <div className="right-buttons">
                                <button onClick={()=>callFunctionToDownloadPdf(newsDetailsData?.attachment_url)} className="circle-btn">
                                    <IonIcon icon={downloadOutline}/>
                                </button>
                                <button className="circle-btn" onClick={()=>callFunctionToBookmarkNews(newsDetailsData?.id,newsDetailsData?.is_bookmarked)}>
                                    <IonIcon className={`${newsDetailsData?.is_bookmarked ? 'bookmarked_icon_color' : ''}`}
                                             icon={newsDetailsData?.is_bookmarked ? bookmark : bookmarkOutline}>
                                    </IonIcon>
                                </button>
                                <button className="circle-btn" onClick={() => handleShareUrl(newsDetailsData)}>
                                    <IonIcon icon={shareSocialOutline}/>
                                </button>
                            </div>
                        </div>

                        <div className="news-detail-overlay" data-publisher-content="true">
                            <div className="news-detail-category">{newsDetailsData.category.charAt(0).toUpperCase() + newsDetailsData.category.slice(1)}</div>
                            <h1 className="news-detail-title">{newsDetailsData.title}</h1>
                        </div>
                    </div>
                    {(isDesktop) ?
                        <div id={'web-ad-banner-horizontal'} className={"add_in_news_detail_page_appear_here"}>
                            Google ads will appear here
                        </div>:''
                    }
                    <div className="news-detail-content" data-publisher-content="true">
                        <div className="news-detail-source">

                            <a className={"source_link_section"} href={newsDetailsData?.source_url}>
                                <span className={"source_just_tap_tag"}>Source: </span><strong>{newsDetailsData?.source}</strong>
                            </a>
                           <span>• {moment(newsDetailsData.created_at).fromNow()}</span>
                        </div>

                        <p data-publisher-content="true" dangerouslySetInnerHTML={{__html:newsDetailsData?.description}}></p>
                        {/* Repeat or add more paragraphs */}
                   </div>
                </>
                :
                <FacebookLoader type={"facebookStyle"} item={4}/>
            }
        </React.Fragment>
    );
}
